import React, { useCallback, useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

const LiveTradingForm = () => {
    const token = localStorage.getItem("token");
    const vertical = "top";
    const horizontal = "center";
    const [message, setMessage] = useState("");
    const [notificationType, setNotificationType] = useState("");
    const [showNotification, setShowNotification] = useState("");
    const [formData, setFormData] = useState({
        assetType: "Cryptocurrency",
        pair: "",
        lotSize: "",
        entryPrice: "",
        stopLoss: "",
        takeProfit: "",
        action: "BUY",
    });

    const [trades, setTrades] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchTrades = useCallback(async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}view-trade`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token,
            },
        });
        const data = await res.json();
        console.log(data);

        setTrades(data.trades);
    }, [token])

    useEffect(() => {
        fetchTrades();
    }, [fetchTrades]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await fetch(`${process.env.REACT_APP_API_URL}create-trade`, {
            method: "POST",
            headers: { "Content-Type": "application/json", token, },
            body: JSON.stringify(formData),
        });
        setLoading(false);
        setShowNotification(true);
        setNotificationType("success");
        setMessage("Trade executed successfully");
        setFormData({ ...formData, pair: "", lotSize: "", entryPrice: "", stopLoss: "", takeProfit: "" });
        fetchTrades();
    };

    return (
        <div style={styles.container}>
            <Snackbar
                open={showNotification}
                autoHideDuration={6000}
                anchorOrigin={{ vertical, horizontal }}
            >
                <Alert
                    message={message}
                    severity={notificationType}
                    className="!text-base"
                >
                    {message}
                </Alert>
            </Snackbar>
            <h3 style={styles.header}>Live Trading</h3>

            <form onSubmit={handleSubmit}>
                <select name="assetType" value={formData.assetType} onChange={handleChange} style={styles.input}>
                    <option>Cryptocurrency</option>
                    <option>Forex</option>
                    <option>Stocks</option>
                </select>

                <label style={styles.label}>Currency Pair</label>
                <input name="pair" value={formData.pair} required onChange={handleChange} style={styles.input} />

                <label style={styles.label}>Lot Size</label>
                <input type="number" name="lotSize" value={formData.lotSize} required={true} onChange={handleChange} style={styles.input} />

                <label style={styles.label}>Entry Price</label>
                <input type="number" name="entryPrice" value={formData.entryPrice} required={true} onChange={handleChange} style={styles.input} />

                <label style={styles.label}>Stop Loss</label>
                <input type="number" name="stopLoss" value={formData.stopLoss} required={true} onChange={handleChange} style={styles.input} />

                <label style={styles.label}>Take Profit</label>
                <input type="number" name="takeProfit" value={formData.takeProfit} required={true} onChange={handleChange} style={styles.input} />

                <select className="my-4" name="action" value={formData.action} required={true} onChange={handleChange} style={styles.input}>
                    <option>BUY</option>
                    <option>SELL</option>
                </select>

                <button style={styles.button} disabled={loading}>
                    {loading ? "Executing..." : "Execute Trade"}
                </button>
            </form>

            {/* RECENT HISTORY */}
            <h4 style={styles.subHeader}>Recent Trading History</h4>

            <div style={styles.tableWrapper}>
                <div style={styles.tableWrapper}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Pair</th>
                                <th style={styles.th}>Action</th>
                                <th style={styles.th}>Lot</th>
                                <th style={styles.th}>Entry</th>
                                <th style={styles.th}>Stop Loss</th>
                                <th style={styles.th}>Take Profit</th>
                                <th style={styles.th}>Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {trades.length === 0 && (
                                <tr>
                                    <td style={styles.td} colSpan="7" align="center">
                                        No trades yet
                                    </td>
                                </tr>
                            )}

                            {trades.map((trade) => (
                                <tr key={trade._id} style={styles.rowHover}>
                                    <td style={styles.td}>{trade.pair}</td>

                                    <td
                                        style={{
                                            ...styles.td,
                                            color: trade.action === "BUY" ? "#2ea043" : "#f85149",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {trade.action}
                                    </td>

                                    <td style={styles.td}>{trade.lotSize}</td>
                                    <td style={styles.td}>{trade.entryPrice}</td>
                                    <td style={styles.td}>{trade.stopLoss || "-"}</td>
                                    <td style={styles.td}>{trade.takeProfit || "-"}</td>
                                    <td style={styles.td}>
                                        {new Date(trade.createdAt).toDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const styles = {
    subHeader: { marginTop: 30, color: "white" },
    label: { color: "white", display: "block", marginTop: 10 },
    container: { padding: 20 },

    header: { color: "white" },

    input: {
        width: "100%",
        padding: 10,
        marginBottom: 8,
        borderRadius: 4,
    },

    button: {
        padding: 12,
        width: "100%",
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: 4,
        cursor: "pointer",
    },

    tableWrapper: {
        overflowX: "auto",
        marginTop: 15,
        borderRadius: 6,
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",   // IMPORTANT
        backgroundColor: "#0d1117",
        color: "#fff",
        minWidth: "900px",            // PREVENT JAMMING
    },

    th: {
        padding: "12px 14px",
        textAlign: "left",
        backgroundColor: "#161b22",
        fontWeight: 600,
        borderBottom: "1px solid #30363d",
        whiteSpace: "nowrap",
    },

    td: {
        padding: "12px 14px",
        borderBottom: "1px solid #21262d",
        whiteSpace: "nowrap",
    },

    rowHover: {
        transition: "background 0.2s ease",
    },
};


export default LiveTradingForm;
